// @flow
import {filterMarkdocTags} from 'docs/util';
import type {RenderNode} from '@markdoc/markdoc';
import {edgeStyle} from './edgeStyle';
import type {Node, Edge, Element, NodeChildren, NodeAttributes} from '../types';

const buildOverviewDiagramNode = (
  attributes: NodeAttributes,
  children: NodeChildren,
): Node => {
  const {id, icon, x, y} = attributes;
  const type = icon ? 'icon' : 'text';
  return {
    id,
    type,
    data: {icon, text: children},
    position: {x, y},
  };
};

// Use the content of the first paragraph as the label
const getLabel = (children: Array<RenderNode>): string => {
  const label = filterMarkdocTags(
    children,
    (tag) => tag.name === 'Paragraph',
  )[0];
  if (label && label.children.length && typeof label.children[0] === 'string') {
    return label.children[0];
  }
  return '';
};

const buildOverviewDiagramEdge = (
  attributes: NodeAttributes,
  children: NodeChildren,
): Edge => {
  const {from, to} = attributes;
  const label = getLabel(children);
  return {
    id: `edge-${from}-${to}`,
    source: from,
    target: to,
    arrowHeadType: 'arrowclosed',
    label,
    ...edgeStyle,
  };
};

export const buildOverviewDiagram = (
  attributes: NodeAttributes,
  children: NodeChildren | null,
): Array<Element> => {
  if (!children) {
    return [];
  }
  const elements = children.map((c) => {
    if (c.name !== 'node' && c.name !== 'edge') {
      // We should never get here due to Markdoc tag validation
      return null;
    }
    return c.name === 'node'
      ? buildOverviewDiagramNode(c.attributes, c.children)
      : buildOverviewDiagramEdge(c.attributes, c.children);
  });
  return elements.filter(Boolean);
};
